// The height in pixels of each row
export const HEIGHT_OF_EACH_ITEM = 60;
export const BUFFER_HEIGHT = 60;
export const AMOUNT_OF_ITEMS_TO_FETCH = 30;
